// removed by extract-text-webpack-plugin
module.exports = {"container":"HeaderConBusqueda__container___3KJh5","divTitulo":"HeaderConBusqueda__divTitulo___3N-2l","menu":"HeaderConBusqueda__menu___uCBMN","inputTexto":"HeaderConBusqueda__inputTexto___1CK1y","filtroColoreado":"HeaderConBusqueda__filtroColoreado___3J53e"};


//////////////////
// WEBPACK FOOTER
// ./frontEnd/components/shared/HeaderConBusqueda.css
// module id = 921
// module chunks = 0